var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[_c('div',{staticClass:"fail_"},[_c('img',{attrs:{"src":require("../assets/fail.png"),"alt":"fail"}}),_c('div',{staticClass:"text_ text_1"},[_vm._v("出错了！投保失败！")]),_c('div',{staticClass:"text_info"},[_c('div',{staticClass:"text_"},[_vm._v("错误原因："+_vm._s(_vm.$route.query.error||'服务端异常，请联系管理员！'))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }